// src/vocabulary/A1/unit4/content.js

const content = {
  level: "A1",
  unit: 4,
  title: "People & Descriptions",
  description:
    "Basic words to describe people and things. Learn how to talk about size, age, and personality.",

  explanation: [
    "This unit helps you describe people and things using simple words.",
    "Words like 'man', 'woman', and 'child' are nouns. They tell us who we are talking about.",
    "Words like 'big', 'small', 'old', and 'young' are adjectives.",
    "Adjectives describe how someone or something is.",
    "In English, adjectives usually come after the verb 'to be'.",
    "For example: The man is old. The room is small.",
    "You can use adjectives to describe people, places, and objects.",
    "Try to describe people you know using simple sentences, such as family members or friends."
  ],

  items: [
    {
      word: "man",
      phonetic: "/mæn/",
      meaning: "رجل",
      example: "The man is very kind."
    },
    {
      word: "woman",
      phonetic: "/ˈwʊmən/",
      meaning: "امرأة",
      example: "The woman works in the hospital."
    },
    {
      word: "child",
      phonetic: "/tʃaɪld/",
      meaning: "طفل",
      example: "The child is playing in the street."
    },
    {
      word: "old",
      phonetic: "/oʊld/",
      meaning: "كبير في السن / قديم",
      example: "My grandfather is old."
    },
    {
      word: "young",
      phonetic: "/jʌŋ/",
      meaning: "شاب / صغير في السن",
      example: "She is young and active."
    },
    {
      word: "big",
      phonetic: "/bɪɡ/",
      meaning: "كبير (الحجم)",
      example: "They live in a big house."
    },
    {
      word: "small",
      phonetic: "/smɔːl/",
      meaning: "صغير",
      example: "It is a small room."
    }
  ]
};

export default content;


